import { useLocation } from "react-router-dom";
import { localeFromPath } from "@/lib/locale";

/** Return the current locale ('en' | 'zh') derived from the URL. */
export function useLocale() {
  const { pathname } = useLocation();
  return localeFromPath(pathname);
}

export default useLocale;
